import React, { useContext, useEffect, useState } from "react";
import logoImage from "../../assets/images/aavgo-logo-dark.png";
import { useNavigate } from "react-router-dom";
import HTTP from "../../services/httpService";
import {
    ArrowLeftOutlined,
    MenuUnfoldOutlined,
    SyncOutlined,
} from "@ant-design/icons";
import { Button, Select, Tooltip } from "antd";
import { LayoutContext } from "antd/lib/layout/layout";
import { SettingContext } from "../../routes";
import { initilizeRabbitConnection } from "../../mqtt";
import DateRangePicker from "./../common/DateRangePicker/DateRangePicker";
import DateTimeRangePicker from "../common/DateRangePicker/DateTimeRangePicker";

let selectedHotelIdArray = [];

const NexusHeader = (
    {
        showBackButton,
        handleFilterChange,
        isHotelFilter,
        selectedHotelId,
        setSelectedHotelId,
        isRefreshAllowed,
        refreshData,
        showRangePicker,
        extraAfter,
        withTime,
        selectedTimeZone,
        setSelectedTimeZone,
        selectedDateTime,
        setSelectedDatetime
    } = {
        showRangePicker: false,
        isRefreshAllowed: false,
        refreshData: () => {},
    },
) => {
    const navigate = useNavigate();
    const [hotelOptions, setHotelOptions] = useState([]);
    const { setCollapsed, isMobile } = useContext(LayoutContext);
    const {
        rabbitClient,
        setRabbitClient,
        setRabbitQueue,
    } = useContext(SettingContext);
    const staff_id = localStorage.getItem(`x-dashboard-staffid`);
    function handleSelectChange(value) {
        setSelectedHotelId([...value]);
        selectedHotelIdArray = value;
        handleFilterChange(value);
    }

    async function fetchNexusHotelList() {
        try {
            const hotelRes = await HTTP("nexus/getNexusHotels", { staff_id });
            if (hotelRes.success) {
                setHotelOptions(hotelRes.data);
            }
        } catch (error) {
            console.log("error in fetching Hotels", error);
        }
    }

    useEffect(() => {
        if (isHotelFilter) fetchNexusHotelList();
    }, []);

    function checkInAllList(rabbitRes) {
        let foundHotel = hotelOptions.some(
            (hotel) => hotel.id === rabbitRes.hotel_id,
        );
        if (foundHotel) handleFilterChange(selectedHotelIdArray);
        else return;
    }

    function updateAgentStatus(rabbitRes) {
        //dummy selectedArray is maintained becuase on first render code is not getting selected hotelIds
        //so to prevent api all length condition is checked
        if (
            selectedHotelIdArray &&
            selectedHotelId &&
            selectedHotelIdArray.length === selectedHotelId.length
        ) {
            if (selectedHotelId.length) {
                if (selectedHotelId.includes(rabbitRes.hotel_id))
                    handleFilterChange(selectedHotelId);
                else return;
            } else {
                checkInAllList(rabbitRes);
            }
        } else return;
    }

    useEffect(() => {
        console.log("rabbitClient", rabbitClient);
        if (!rabbitClient) {
            const client = initilizeRabbitConnection();
            setRabbitClient(client);
        }
    }, [rabbitClient]);

    useEffect(() => {
        if (rabbitClient) {
            console.log(
                "listening to the socket events........................YESSSSS",
            );
            rabbitClient.on("message", (topic, message) => {
                let textDecoder = new TextDecoder();
                let result = JSON.parse(textDecoder.decode(message));
                console.log("queue-messages ===>", result);
                if (result?.flag === 102) {
                    updateAgentStatus(result);
                }
                setRabbitQueue(result);
                return;
            });
        }
        return () => {};
    }, [selectedHotelId, hotelOptions]);

    return (
        <div className="dashboard-search-filter">
            {isMobile && (
                <div
                    style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "start",
                    }}
                >
                    <MenuUnfoldOutlined onClick={() => setCollapsed(false)} />
                </div>
            )}
            <div className="logo">
                <img
                    src={logoImage}
                    alt="AavGo"
                    onClick={() => navigate(`/`)}
                    className="logo-image"
                />
            </div>

            {isHotelFilter && (
                <Select
                    defaultValue={selectedHotelId}
                    value={selectedHotelId}
                    showSearch
                    mode="multiple"
                    allowClear
                    className="select-container margin-right-5"
                    placeholder="Hotel Name"
                    filterOption={(input, option) =>
                        option.children
                            .toLowerCase()
                            .includes(input.toLowerCase())
                    }
                    onChange={handleSelectChange}
                    loading={hotelOptions.length === 0 ? true : false}
                >
                    {hotelOptions?.length > 0 &&
                        hotelOptions.map((option) => (
                            <Select.Option key={option.id} value={option.id}>
                                {`${option.id} - ${option.name} - ${option.city}`}
                            </Select.Option>
                        ))}
                </Select>
            )}

            {showRangePicker ? (
                withTime ? (
                    <DateTimeRangePicker
                        selectedDates={selectedDateTime}
                        setSelectedDates={setSelectedDatetime}
                        selectedTimeZone={selectedTimeZone}
                        setSelectedTimeZone={setSelectedTimeZone}
                    />
                ) : (
                    <DateRangePicker
                        selectedDates={selectedDateTime}
                        setSelectedDates={setSelectedDatetime}
                    />
                )
            ) : null}
            {extraAfter ?? ""}
            {isRefreshAllowed && (
                <Tooltip title="Reload" placement="bottomLeft">
                    <Button
                        type="primary"
                        icon={<SyncOutlined style={{ fontSize: "15px" }} />}
                        className="margin-right-5"
                        onClick={() => {
                            refreshData();
                        }}
                        // href="https://www.google.com"
                    />
                </Tooltip>
            )}
            <div className="icon-container">
                {showBackButton ? (
                    <Button
                        className="margin-left-10"
                        type="primary"
                        onClick={() => navigate(-1)}
                    >
                        <ArrowLeftOutlined /> Back
                    </Button>
                ) : null}
            </div>
        </div>
    );
};

export default NexusHeader;
